import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const brand = content.brand;
  const f = content.footer || {};
  const links = [
    { label: "LinkedIn", href: f.linkedin, testid: "footer-linkedin" },
    { label: "Fiverr", href: f.fiverr, testid: "footer-fiverr" },
    { label: "Upwork", href: f.upwork, testid: "footer-upwork" },
  ].filter((l) => l.href);

  return (
    <footer className="border-t border-slate-800/60 py-10">
      <div className="max-w-5xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="font-display font-black text-lg tracking-tight text-slate-200">
          {brand.name_pre}
          <span className="text-sky-400"> {brand.name_accent}</span>
        </p>
        <div className="flex items-center gap-5" data-testid="footer-social-links">
          {links.map((l) => (
            <a
              key={l.label}
              href={l.href}
              target="_blank"
              rel="noreferrer"
              data-testid={l.testid}
              className="text-sm text-slate-400 hover:text-sky-400 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </div>
        <p className="text-xs text-slate-600">
          © {new Date().getFullYear()} {content.footer?.name} · All rights reserved
        </p>
        <Link
          to="/admin/login"
          data-testid="footer-admin-link"
          className="text-xs uppercase tracking-wider text-slate-600 hover:text-sky-400 transition-colors"
        >
          Admin
        </Link>
      </div>
    </footer>
  );
};
